<template>

  <!-- Map -->

  <div v-if="dataReady" class="container-fluid mb-6" style="max-width: 1200px; margin: 0 auto">
    <div class="row align-items-center">
      <div
        data-aos="fade-up"
        class="col-md-5 offset-md-1 bg-white text-center"
      >
        <div class="spots-map d-inline-block mb-3">
          <img
            class="img-fluid mx-auto"
            src="../../images/map.png"
            alt="Karte"
          />

          <div id="spots">
            <div
              v-for="(location, index) in city"
              v-bind:style="location.positionStyles"
              class="position-absolute"
              :key="index"
            >
              <label class="marker-group">
                <input
                  @click="scrollToSection('getOfferSectionSplide')"
                  :id="'spot-' + location.name"
                  :ref="'spot' + location.name"
                  type="radio"
                  name="city"
                  :value="index"
                  v-model="selectedCity"
                />
                <span
                  v-if="location.name !== 'Duisburg' && location.name !== ''"
                  class="spot-icon"
                ></span>
                <img
                  v-else
                  class="position-absolute"
                  style="max-width: 17px; opacity: 1; bottom: 18px"
                  src="../../images/map-marker.svg"
                  :alt="location.name"
                />
                <span
                  class="spot-text"
                  v-bind:class="location.positionClass"
                  >{{ location.name }}</span
                >
              </label>
            </div>
          </div>
        </div>

        <div
          class="d-none d-md-flex justify-content-center align-items-center"
        >
          <img
            class="mr-1"
            style="max-width: 17px; opacity: 1"
            src="../../images/map-marker.svg"
            alt="Marker"
          />
          <span>Sitz der GSI</span>
        </div>
        <div
          class="d-none d-md-flex justify-content-center align-items-center"
        >
          <div
            class="rounded-circle mr-1"
            style="border: 3px solid #96c223; width: 15px; height: 15px"
          ></div>
          <span>Niederlassungen der GSI</span>
        </div>
      </div>

      <!-- END Map -->

      <!-- Contact Info -->

      <div class="col-md-6 splide-container" ref="getOfferSectionSplide">

        <!-- Mobile -->

        <splide
          id="getOfferSection"
          ref="getOfferSection"
          :options="getSplideOptions"
          @splide:moved="moved"
          class="d-md-none"
        >
          <splide-slide
            v-for="(c, index) in city"
            v-bind:key="index"
          >
            <location-info v-bind:c=c v-bind:cityIndex=index :isMobile="true"></location-info>
          </splide-slide>
        </splide>

        <!-- Desktop -->

        <div
          id="getOfferSectionDT"
          class="d-none d-md-block"
        >
          <div
            v-for="(c, index) in city"
            v-bind:key="index"
            :class="index == selectedCity ? 'd-md-block' : 'd-md-none'"
          >
            <location-info v-bind:c=c v-bind:cityIndex=index :isMobile="false"></location-info>
          </div>
        </div>

      </div>

       <!-- END Contact Info -->


    </div>
  </div>

</template>

<script>
import LocationInfo from './LocationInfo.vue';
export default {
components: { LocationInfo },
data: function () {
  return {
    dataReady: false,
    contact: "",
    selectedCity: 0,
    city: [],
  };
},
methods: {
  moved(splide, newIndex) {
    this.selectedCity = newIndex;
  },
  scrollToSection(refName) {
    let el = this.$refs[refName];
    let elHeight = el.clientHeight;
    let offsetVal = document.documentElement.clientHeight - elHeight;
    let options = {
      offset: -offsetVal
    }
    if ( window.innerWidth<768 && !this.isElementInViewport(el)) {
        this.$scrollTo(el, options)
    }

  },
  isElementInViewport (el) {

      var rect = el.getBoundingClientRect();

      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      );
  }
},
computed: {
  getSplideOptions() {
    return {
      type: "loop",
      start: this.selectedCity,
      drag: true,
      padding: {
        right: "10%",
        left: "10%",
      },
    };
  },
},
watch: {
  selectedCity(n) {
    this.$refs["getOfferSection"].go(n);
  },
},
async mounted() {
  let _this = this;
  await axios
    .get("/api/map-get-city-contacts")
    .then(function(response){
      _this.city = response.data;
      _this.dataReady = true;
    });
},
};
</script>
<style>
#map-section .splide__arrow,
#map-section .splide__pagination {
display: none;
}
</style>

<style lang="scss" scoped>

@import "resources/sass/_variables.scss";

/* Map Spots */
.spots-map {
position: relative;
}

.spots-map img {
display: block;
}

.spots {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}

.marker-group {
position: absolute;
z-index: 1;
margin: 0;
line-height: 1;
cursor: pointer;
-webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
user-select: none;
display: flex;
justify-content: center;
}

.marker-group input {
position: absolute;
opacity: 0;
cursor: pointer;
}

.marker-group .spot-icon {
animation: pulse 1s infinite;
position: absolute;
display: flex;
justify-content: center;
align-items: center;
width: 15px;
height: 15px;
border-radius: 50%;
border: 3px solid #96c223;
background-color: transparent;
box-shadow: 0 0 0 rgba(238, 116, 2, 0.4);
transition: all 0.2s ease-in-out;
}

.marker-group .spot-text {
color: #0066b3;
font-size: 1rem;
font-weight: normal;
transition: all 0.2s ease-in-out;
text-align: center;
}

/* Show the indicator (dot/circle) when checked */
.marker-group input:checked ~ .spot-icon:after {
display: block;
}

/* Show the indicator (dot/circle) when checked */
.marker-group input:checked ~ .spot-icon {
animation: none;
}

/* Show the indicator (dot/circle) when checked */
.marker-group input:checked ~ .spot-text {
font-weight: 700;
color: #0066b3;
}

/* Style the indicator (dot/circle) */
.marker-group .spot-icon:after {
content: "";
position: absolute;
display: none;
width: 100%;
height: 100%;
border-radius: 50%;
background: #96c223;
transition: all 0.2s ease-in-out;
}

.marker-group .spot-icon:hover {
animation: none;
cursor: pointer;
}

.spot-top {
margin-top: -20px;
}

.spot-bottom {
margin-top: 20px;
}
@media screen and (min-width: 768px) {
.location-card {
  max-width: 310px;
}
}


@media screen and (max-width: 480px) {
.location-address > p {
  font-size: 14px;
  line-height: 20px;
}
}



@media screen and (max-width: 767px) {

.splide-container {
  top: -50px;
  margin-bottom: -50px;
}
}
.spots-map {
max-width: 365px;
margin: 0 auto;
}
@keyframes pulse {
0% {
  transform: scale(1);
}

50% {
  transform: scale(1.15);
}

100% {
  transform: scale(1);
}
}
</style>
